import { clsx } from "clsx";
import type { ButtonHTMLAttributes } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "ghost";
  size?: "md" | "lg";
}

export function Button({ variant = "primary", size = "md", className, ...rest }: Props) {
  return <button className={clsx("ui-btn", `ui-btn-${variant}`, `ui-btn-${size}`, className)} {...rest} />;
}
